export default "__VITE_ASSET__qfy1kDZH__"